import React from "react";
import { IMAGES } from "../Utils";
import "../Assets/Style/ViewBlog.css";

function ViewBlog_webdesign() {
  return (
    <>
      {" "}
      <div className="viewBlogBody">
        <div className="row blogsBanner">
          <div className="blog-bg-banner">
            <div className="container blogText">
              <div>
                <h3>Blogs</h3>
                <h5>A directory of wonderful things</h5>
              </div>
            </div>
          </div>
        </div>
        <div className="container ">
          <div className="viewBlogSection">
            <div className="row">
              <div className="col-lg-8">
                <div className="blogImage">
                  <img src={IMAGES.BlogInnerDM} alt=" img for blog" />
                </div>
                <div className="profile">
                  <ul>
                    <li>DThrill Software Solutions LLP</li>
                    <li>Web Design</li>
                  </ul>
                </div>

                <div className="blogTitle">
                  <h3>What is web design</h3>
                </div>

                <div className="blogDescription">
                  <div className="blog-para">
                    <p>
                      Web Design is the process of making websites and mobile
                      applications appealing to the target audience. The web
                      designer needs to be good at creative techniques, and
                      design skills, along with a strong foundation in the most
                      recent technology of the web. The best web designers know
                      that good web design can be attracted by the users and
                      should reach Industry expectations.
                    </p>
                  </div>
                  <div className="blog-para">
                    <h5>Basic languages</h5>
                  </div>
                  <div className="blog-para">
                    <p>
                      <span>HTML - </span>The Hypertext Markup Language is the
                      most basic and must know for any website you are
                      contriving. You define and structure the content of a
                      website.
                    </p>
                  </div>
                  <div className="blog-para">
                    <p>
                      <span>CSS - </span>This is used for styling websites and
                      adding layouts, fonts, and colors.
                    </p>
                  </div>
                  <div className="blog-para">
                    <p>
                      {" "}
                      <span>SQL - </span>
                      Structured Query Language; this is a basic language that
                      is used for database management.
                    </p>
                  </div>
                  <div className="blog-para">
                    <h5>Front-end frameworks</h5>
                  </div>

                  <div className="blog-para">
                    <p>
                      {" "}
                      <span>Bootstrap - </span>
                      An open-source toolkit for developing responsive,
                      mobile-first projects. Uses HTML, CSS and JavaScript. It
                      helps design the website faster and easier. It has design
                      templates for forms, buttons, tables, navigation, etc., It
                      also supports JavaScript plugins.
                    </p>
                  </div>
                  <div className="blog-para">
                    <p>
                      {" "}
                      <span>AngularJS - </span>
                      This a structural framework for dynamic web apps. The
                      JavaScript-based open-source web framework is maintained
                      by Google and a community of corporations and individuals.
                      It allows the usage of HTML as the template language.
                    </p>
                  </div>

                  <div className="blog-para">
                    <p>
                      <span>React Js - </span>A JavaScript library maintained by
                      Facebook and a group of companies as well as individual
                      developers. React is optimal for fetching fast-changing
                      data that needs to be recorded. It is used for building
                      user interfaces for single-page applications. It allows
                      users to create reusable UI components.
                    </p>
                  </div>

                  <div className="blog-para">
                    <h5>Programming languages</h5>
                  </div>

                  <div className="blog-para">
                    <p>
                      {" "}
                      <span>JavaScript - </span>
                      It helps in adding dynamic features to your website and is
                      the predominant usage of JavaScript. This is used for both
                      front end and back end operations. The JavaScript basics
                      are easy to learn. Many of the front-end as well as
                      back-end frameworks, like NodeJS and AngularJS, use
                      JavaScript.
                    </p>
                  </div>
                  <div className="blog-para">
                    <p>
                      {" "}
                      <span>PHP - </span>
                      The most popular scripting language, it can be embedded
                      into HTML. PHP scripts can only be interpreted on a server
                      where PHP is installed. It is used to collect form data,
                      send or receive cookies amongst other functions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="recentStorySection">
                  <div>
                    <div className="recentStory">
                      <h3>Recent Stories</h3>
                    </div>

                    <div className="recentStoryList">
                      <div className="blogImage">
                        <img src={IMAGES.Compition} alt=" img for blog" />
                      </div>
                      <div className="recentBlogInfo">
                        <p>Adverto Just Pushes Deeper Into Agency</p>
                        <p>Apr 14, 2023</p>
                      </div>
                    </div>
                    <div className="recentStoryList">
                      <div className="blogImage">
                        <img src={IMAGES.Compition} alt=" img for blog" />
                      </div>
                      <div className="recentBlogInfo">
                        <p>Adverto Just Pushes Deeper Into Agency</p>
                        <p>Apr 14, 2023</p>
                      </div>
                    </div>
                  </div>
                  <div className="categories">
                    <div className="recentStory">
                      <h3>Categories</h3>
                    </div>
                    <ul>
                      <li>Agency</li>
                      <li>comuter</li>
                      <li>development</li>
                      <li>designer</li>
                      <li>Graphic Design</li>
                      <li>Digital Marketing</li>
                    </ul>
                  </div>

                  <div className="Tags">
                    <div className="recentStory">
                      <h3>Tags</h3>
                    </div>
                    <div className="row tagsList">
                      <div className="col-lg-12">
                        <a>Agency</a>
                      </div>
                      <div className="col-lg-12">
                        <a>Comuter</a>
                      </div>
                      <div className="col-lg-12">
                        <a>Development</a>
                      </div>
                      <div className="col-lg-12">
                        <a>Designer</a>
                      </div>
                      <div className="col-lg-12">
                        <a>Graphics Design</a>
                      </div>
                      <div className="col-lg-12">
                        <a>Digital Marketing</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewBlog_webdesign;
